import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import PrismicVue from 'prismic-vue'
import linkResolver from './prismic/link-resolver'
import htmlSerializer from './prismic/html-serializer'

import underscore from 'vue-underscore';

import VueWait from 'vue-wait'

import vueVimeoPlayer from 'vue-vimeo-player'

import VuePageTransition from 'vue-page-transition'

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "G-D8PLWQ6514" }
});

Vue.use(VuePageTransition)

Vue.use(VueWait)

Vue.use(vueVimeoPlayer)

Vue.use(underscore)

Vue.config.productionTip = false

Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  linkResolver,
  htmlSerializer
})

new Vue({
  router,
  store,
  wait: new VueWait({
    useVuex: true
  }),
  render: function (h) { return h(App) }
}).$mount('#app')
